export const ROLE = {
  SuperAdmin: "SuperAdmin",
  Admin: "Admin",
  User: "User"
}

export const domain = {
  SuperAdminUrl: "https://admin.cheersbeaslayers.in/",
  AdminUrl: "https://clubs.cheersbeaslayers.in/",
  localUrl:"localhost:3000"

}